
import { Folder } from './types';

/**
 * Default folders used as initial state
 */
export const DEFAULT_FOLDERS: Folder[] = [
  {
    id: 'folder1',
    name: 'VSLs Principais',
    color: '#8b5cf6',
    count: 0,
    createdAt: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(),
    emoji: '🎬'
  },
  {
    id: 'folder2',
    name: 'Campanhas Recentes',
    color: '#10b981',
    count: 0,
    createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    emoji: '🚀'
  }
];

